// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/Image-upload.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-name .textarea-field {
  height: 56px !important;
  min-height: 0 !important;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.error-text.textarea-container .label {
  color: #D92D20 !important;
}

.date-picker-wrapper {
  width: 100% !important;
}

.react-datepicker-wrapper {
  width: 100% !important;
}

.datepicker-dropdown {
  width: -webkit-fill-available !important;
}

.dropdown-container {
  border-radius: 12px;
  border: 1px solid #F3F3F3;
  background: #FDFDFD;
}

.dropdown-item:hover {
  background-color: #F3F3F3;
}

.dropzone {
  position: relative;
  width: 75%;
  max-width: 100%;
  aspect-ratio: 16/9;
  display: flex;
  padding: 54px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  align-self: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 12px;
}

.displayzone {
  position: relative;
  width: 75%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  border-radius: 12px;
}

.displayImage {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;
  border-radius: 12px;
}

.crop-btn {
  display: flex;
  height: 32px;
  padding: 8px 16px !important;
  justify-content: center;
  align-items: center;
}

.slider-container {
  display: flex;
  align-items: center;
}

.slider {
  width: 100%;
  height: 6px;
  border: none;
  outline: none;
  opacity: 0.9;
  border-radius: 5px;
  margin: 0 10px;
  accent-color: #101010;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  cursor: pointer;
  border-radius: 50%;
}

#event-description-editor {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.terms-and-conditions .ql-blank::before {
  content: "Add specific terms and conditions for this event. Example:\\a 1. Tickets are non-refundable. \\a 2. Entry is allowed only with a valid ticket." !important;
  white-space: pre-wrap;
  display: block;
}

.ql-container {
  min-height: 200px;
  max-height: 200px; /* fixed approx height per request */
  overflow: auto;
  border-bottom-left-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 19.6px !important;
  flex: 1;
}
.ql-container .ql-editor {
  height: auto;
  min-height: 200px;
}

.ql-snow.ql-toolbar {
  display: block;
  background: #F3F3F3;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
}

.modal-content {
  overflow: auto !important;
}

.modal-edit .modal-container.regular {
  height: 340px !important;
}

.modal-edit .modal-container.regular .modal-content {
  padding: 0 24px !important;
}

.modal-delete .modal-header {
  padding: 0 !important;
}
.modal-delete .modal-content {
  overflow: hidden !important;
}

@media (max-width: 650px) {
  .modal-edit .modal-header {
    display: none !important;
  }
  .modal-edit .modal-container.regular {
    width: calc(100% - 24px) !important;
    max-width: 640px !important;
    height: auto !important;
    max-height: none !important;
  }
  .modal-edit .modal-container.regular .modal-content {
    padding: 0 24px 20px !important;
    max-height: none !important;
    overflow: visible !important;
  }
  .modal-edit .modal-container.regular .modal-content > div {
    padding: 0 !important;
  }
  .modal-edit .crop-mobile-header {
    flex-wrap: nowrap !important;
    margin-bottom: 16px;
  }
  .modal-edit .crop-close-btn {
    width: 40px;
    height: 40px;
    border-radius: 9999px;
    background: #F3F3F3;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .event-about-container {
    overflow: auto !important;
    padding-right: 0 !important;
  }
  .event-about-container .city-dropdown .menu-wrapper {
    position: static !important;
    top: auto !important;
    margin-top: 8px;
    max-height: 240px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/event-create/components/step-1/style.scss"],"names":[],"mappings":"AAGA;EACI,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,+BAAA;AAFJ;;AAMA;EACI,yBAAA;AAHJ;;AAOA;EACI,sBAAA;AAJJ;;AAMA;EACI,sBAAA;AAHJ;;AAKA;EACI,wCAAA;AAFJ;;AAMA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;AAHJ;;AAKA;EACI,yBAAA;AAFJ;;AAMA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;AAHJ;;AAKA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;;AAIA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAGA;EACI,aAAA;EACA,mBAAA;AAAJ;;AAEA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AACA;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAEF;;AACA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;AAEJ;;AAEI;EACI,kKAAA;EACA,qBAAA;EACA,cAAA;AACR;;AAIA;EACI,iBAAA;EACA,iBAAA,EAAA,oCAAA;EACA,cAAA;EACA,gCAAA;EACA,iCAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;EACA,OAAA;AADJ;AAGI;EACI,YAAA;EACA,iBAAA;AADR;;AAIA;EACI,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,8BAAA;AADJ;;AAKA;EACI,yBAAA;AAFJ;;AAMA;EACI,wBAAA;AAHJ;;AAMA;EACI,0BAAA;AAHJ;;AAQI;EACI,qBAAA;AALR;AAOI;EACI,2BAAA;AALR;;AASA;EAEQ;IACI,wBAAA;EAPV;EAUM;IACI,mCAAA;IACA,2BAAA;IACA,uBAAA;IACA,2BAAA;EARV;EAWM;IACI,+BAAA;IACA,2BAAA;IACA,4BAAA;EATV;EAYM;IACI,qBAAA;EAVV;EAaM;IACI,4BAAA;IACA,mBAAA;EAXV;EAcM;IACI,WAAA;IACA,YAAA;IACA,qBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,cAAA;EAZV;EAgBE;IACI,yBAAA;IACA,2BAAA;EAdN;EAkBM;IACI,2BAAA;IACA,oBAAA;IACA,eAAA;IACA,iBAAA;EAhBV;AACF","sourcesContent":["@charset \"UTF-8\";\n\n//eventAbout\n.event-name .textarea-field {\n    height: 56px !important;\n    min-height: 0 !important;\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n}\n\n//eventAbout - error message\n.error-text.textarea-container .label{\n    color: theme('colors.error') !important;\n}\n\n//eventOccasion\n.date-picker-wrapper{\n    width: 100% !important;\n}\n.react-datepicker-wrapper{\n    width: 100% !important;\n}\n.datepicker-dropdown{\n    width: -webkit-fill-available !important;\n}\n\n//eventOccasion -> venueDropDown\n.dropdown-container {\n    border-radius: 12px;\n    border: 1px solid theme('colors.grey-10');\n    background: theme('colors.white');\n}\n.dropdown-item:hover{\n    background-color: theme('colors.grey-10');\n}\n\n//eventImage -> ImageUpload\n.dropzone{\n    position: relative;\n    width: 75%;\n    max-width: 100%;\n    aspect-ratio: 16 / 9;\n    display: flex;\n    padding: 54px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    align-self: center;\n    background-image: url(\"/assets/images/Image-upload.svg\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 12px;\n}\n.displayzone{\n    position: relative;\n    width: 75%;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-self: center;\n    border-radius: 12px;\n}\n.displayImage{\n    display: block;\n    width: 100%;\n    height: auto;\n    aspect-ratio: 16 / 9;\n    border-radius: 12px;\n\n}\n.crop-btn{\n    display: flex;\n    height: 32px;\n    padding: 8px 16px !important;\n    justify-content: center;\n    align-items: center;\n}\n.slider-container {\n    display: flex;\n    align-items: center;\n}\n.slider {\n  width: 100%;\n  height: 6px;\n  border: none;\n  outline: none;\n  opacity: 0.9;\n  border-radius: 5px;\n  margin: 0 10px;\n  accent-color: theme('colors.black')\n}\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n#event-description-editor {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.terms-and-conditions {\n    .ql-blank::before {\n        content: \"Add specific terms and conditions for this event. Example:\\A 1. Tickets are non-refundable. \\A 2. Entry is allowed only with a valid ticket.\" !important;\n        white-space: pre-wrap;\n        display: block;\n    }\n}\n\n//eventDescription\n.ql-container {\n    min-height: 200px;\n    max-height: 200px; /* fixed approx height per request */\n    overflow: auto;\n    border-bottom-left-radius: 0.5em;\n    border-bottom-right-radius: 0.5em;\n    font-weight: 400 !important;\n    font-size: 14px !important;\n    line-height: 19.6px !important;\n    flex: 1;\n\n    .ql-editor {\n        height: auto;\n        min-height: 200px;\n    }\n}\n.ql-snow.ql-toolbar {\n    display: block;\n    background: theme('colors.grey-10');\n    border-top-left-radius: 0.5em;\n    border-top-right-radius: 0.5em;\n}\n\n//question Modal\n.modal-content{\n    overflow: auto !important;\n}\n\n//image-edit Modal\n.modal-edit .modal-container.regular{\n    height: 340px !important;\n}\n\n.modal-edit .modal-container.regular .modal-content{\n    padding: 0 24px !important;\n}  \n\n//image-delete Modal\n.modal-delete{\n    .modal-header{\n        padding: 0 !important;\n    }  \n    .modal-content{\n        overflow: hidden !important;\n    }\n}\n\n@media (max-width: 650px) {\n    .modal-edit {\n        .modal-header {\n            display: none !important;\n        }\n\n        .modal-container.regular {\n            width: calc(100% - 24px) !important;\n            max-width: 640px !important;\n            height: auto !important;\n            max-height: none !important;\n        }\n\n        .modal-container.regular .modal-content {\n            padding: 0 24px 20px !important;\n            max-height: none !important;\n            overflow: visible !important;\n        }\n\n        .modal-container.regular .modal-content > div {\n            padding: 0 !important;\n        }\n\n        .crop-mobile-header {\n            flex-wrap: nowrap !important;\n            margin-bottom: 16px;\n        }\n\n        .crop-close-btn {\n            width: 40px;\n            height: 40px;\n            border-radius: 9999px;\n            background: theme('colors.grey-10');\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n        }\n    }\n\n    .event-about-container {\n        overflow: auto !important;\n        padding-right: 0 !important;\n    }\n\n    .event-about-container .city-dropdown {\n        .menu-wrapper {\n            position: static !important;\n            top: auto !important;\n            margin-top: 8px;\n            max-height: 240px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
